const appUrl = (import.meta.env.VITE_APP_URL as string) || 'https://app.open-muse.com'

export function appHomeUrl(): string {
  return appUrl
}

export function appPathUrl(path: string): string {
  return `${appUrl}${path.startsWith('/') ? path : '/' + path}`
}

export function appLoginUrl(opts: { mode?: 'signin' | 'signup'; returnUrl?: string } = {}): string {
  const params = new URLSearchParams()
  if (opts.mode === 'signup') params.set('mode', 'signup')
  if (opts.returnUrl) params.set('returnUrl', opts.returnUrl)
  const qs = params.toString()
  return `${appUrl}/login${qs ? '?' + qs : ''}`
}
